<div class="popup-container">
    <button type="button" class="close_button" aria-label="Close" (click)="closeDialog()">
        <img src="assets/images/Close_btn.svg" alt="Close">
    </button>

    <div class="popup-header" id="err">
        <h2 class="mb-0 mr-0">AET Events/Resolution upload</h2>
    </div>

    <div class="logs-container" #logsContainer>
        <div class="err-content" *ngFor="let i of displaydata">{{i.message}}</div>
        <div class="err-content" *ngIf="!displaydata?.length && errormsg">{{errormsg}}</div>
    </div>
</div>